export default "__VITE_ASSET__b7PY8iEp__"